// DOM overlay shown when the WS is closed/errored. Rendered outside the Three.js canvas so
// Playwright can probe for it via `data-scene="connection-lost"`.

export interface ConnectionLostHandle {
  el: HTMLDivElement;
  setState: (state: 'open' | 'closed' | 'error' | 'connecting' | 'idle') => void;
  setRetryIn: (ms: number | null) => void;
  dispose: () => void;
}

export function createConnectionLost(mount: HTMLElement): ConnectionLostHandle {
  const el = document.createElement('div');
  el.setAttribute('data-scene', 'connection-lost');
  el.style.position = 'absolute';
  el.style.inset = '0';
  el.style.display = 'none';
  el.style.zIndex = '1000';
  el.style.background = 'rgba(4, 5, 22, 0.94)';
  el.style.color = '#fff';
  el.style.alignItems = 'center';
  el.style.justifyContent = 'center';
  el.style.flexDirection = 'column';
  el.style.gap = '1rem';
  el.style.fontFamily = `'Inter', system-ui, sans-serif`;
  el.innerHTML = `
    <div style="font-size:3rem;letter-spacing:.08em;font-weight:700;color:#FFC43D">CONNECTION LOST</div>
    <div data-testid="conn-banner-msg" style="font-size:1.25rem;opacity:0.85">Reconnecting…</div>
    <div data-testid="conn-banner-retry" style="font-size:1rem;opacity:0.7"></div>
  `;
  mount.appendChild(el);

  const msg = el.querySelector<HTMLDivElement>('[data-testid="conn-banner-msg"]')!;
  const retry = el.querySelector<HTMLDivElement>('[data-testid="conn-banner-retry"]')!;

  function setState(state: 'open' | 'closed' | 'error' | 'connecting' | 'idle'): void {
    if (state === 'open') {
      el.style.display = 'none';
      return;
    }
    el.style.display = 'flex';
    if (state === 'error') msg.textContent = 'Connection error. Retrying…';
    else if (state === 'closed') msg.textContent = 'Disconnected. Retrying…';
    else msg.textContent = 'Connecting…';
  }

  function setRetryIn(ms: number | null): void {
    retry.textContent = ms === null ? '' : `Next retry in ${Math.ceil(ms / 1000)}s`;
  }

  return {
    el,
    setState,
    setRetryIn,
    dispose() {
      el.remove();
    },
  };
}
